import tryCall from '@v/util/tryCall.js'
import { assoc } from 'ramda'
import FunnelSettingsSaveModel from './FunnelSettingsSaveModel.js'

export default class FunnelSettingsService {
  constructor(vue, imageService) {
    this.vue = vue
    this.imageService = imageService
  }

  async fetchFunnelSettings() {
    const response = await this.vue.$apiClient.get('settings/application/funnel')
    const data = response.data
    return this.mapApiModelToViewModel(data)
  }

  // todo: use safeApiClient
  async save({ settings }) {
    const dataToSave = new FunnelSettingsSaveModel(settings, settings.CustomDomainName)
    return await tryCall(
      async () => await this.vue.$apiClient.post('settings/application/funnel', dataToSave),
      'Could not save settings!',
    )
  }

  async resolveImageUrl({ file, settings, field, remove }) {
    if (remove && !file) return { data: null, success: true }
    if (file) {
      const result = await this.imageService.saveImage(file)
      return { data: result.data, success: result.success }
    }
    return { data: settings[field], success: true }
  }

  mapApiModelToViewModel(data) {
    const baseObject = {
      ...data.BusinessUnitFunnel,
      CustomDomainName: data.CustomDomain?.DomainName,
      CustomDomainVerified: data.CustomDomain?.Verified,
      FunnelUrl: data.FunnelUrl,
      BusinessUnitKey: data.Settings[0]?.BusinessUnitKey,
    }
    return data.Settings.reduce((a, n) => assoc(n.SettingKey, n.Values[0], a), baseObject)
  }
}
